<template>
    <section v-if="pageLoader">
        <div class="page-loader">
            {{ $t("loading.loading") }}
        </div>
    </section>
    <section v-else class="photos">
        <div v-if="!albumsIsEmpty('details')" class="section-header section-header-alt">
            <div class="container-mobile">
                <div v-if="profileId != user.id && isPuzzle" class="heading">
                    <div class="photos-owner user-item" :class="{
                        online: album.owner.online,
                    }">
                        <router-link :to="'/profile/' + album.owner.id" :style="{
                            'background-image': album.owner.avatar
                                ? 'url(' + album.owner.avatar + ')'
                                : '',
                        }" class="user-item-avatar" :class="{
    'no-avatar': !album.owner.avatar,
}"></router-link>
                        <div class="user-item-info">
                            <router-link :to="'/profile/' + album.owner.id" class="user-item-title">{{ album.owner.name
                            }}</router-link>
                            <div v-if="album.owner.city || album.owner.birthday.length == 10" class="user-item-subtitle">
                                <span v-if="album.owner.city">{{ album.owner.city }}</span><span
                                    v-if="album.owner.city && album.owner.birthday.length == 10">,</span>
                                <span v-if="album.owner.birthday.length == 10">
                                    {{ calcAge() }}
                                    {{
                                        declineNouns(calcAge(), [
                                            $t("photos.year"),
                                            $t("photos.ofTheYear"),
                                            $t("photos.years"),
                                        ])
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <h2 v-else class="heading">
                    {{ album.title }}
                    <router-link v-if="profileId != user.id" :to="{ name: 'profile', params: { id: profileId } }"
                        class="link-inherit">
                        ({{ album.owner.name }})
                    </router-link>
                </h2> -->
                <div v-else class="album-editable-header albums-breadcrumbs">
                    <ul class="container-mobile album-edit-breadcrumbs" style="width: 100%">
                        <li class="album-edit-breadcrumbs-arrow">
                            <router-link :to="{ name: 'profile', params: { id: profileId } }">
                                {{ shortenedOwnerName }}
                            </router-link>
                        </li>
                        <li class="album-edit-breadcrumbs-arrow">
                            <router-link
                                :to="{
                                    name: isVideo ? 'video-albums' : 'albums',
                                    params: { profileId: profileId },
                                }">
                                <!-- {{ $t("photos.my") }} -->
                                {{ isVideo ? $t("photos.video") : $t("photos.photo") }}

                                <!-- {{ album.is_owner ? (isVideo ? $t("photos.my") + " " + $t("albums.video") : $t("photos.my")
                                    + " " +
                                    $t("albums.photo"))
                                    : (isVideo ? $t("photos.video") : $t("photos.photo")) }} -->
                            </router-link>
                        </li>
                        <li class="album-edit-breadcrumbs-overflow">
                            <div>
                                {{ album.title === "Общий" ? $t("albums.general") : album.title }}
                            </div>
                        </li>
                    </ul>
                </div>
                <div @click="showContext = !showContext" ref="contextButton" class="context-opener photos-context-opener"
                    :class="{ 'context-opener-open': showContext }"></div>
                <div v-if="profileId == user.id" class="photos-links">
                    <redirectButton v-if="profileId == user.id" :pathname="(isVideo ? 'video-' : '') + 'albums-edit'"
                        :params="{ albumId: albumId }" :html="$t('photos.editAlbum')" class="link"></redirectButton>
                    <span @click="
                        $modal.show('upload-photos', { album: album, isVideo: isVideo })
                        " class="link">{{ $t("photos.add") }}
                        {{ isVideo ? $t("photos.video") : $t("photos.photo") }}
                    </span>
                </div>
                <div v-if="profileId == user.id && showContext" class="photos-links-mobile context">
                    <redirectButton v-if="profileId == user.id" :pathname="(isVideo ? 'video-' : '') + 'albums-edit'"
                        :params="{ albumId: albumId }" html="Редактировать альбом" class="context-item"></redirectButton>
                    <span @click="
                        $modal.show('upload-photos', { album: album, isVideo: isVideo });
                    showContext = false;
                    " class="context-item">{{ $t("photos.add") }}
                        {{ isVideo ? $t("photos.video") : $t("photos.photo") }}
                    </span>
                </div>
            </div>
        </div>

        <div class="info-block container-mobile">
            <div v-if="album.description" class="photos-description">
                {{ album.description }}
            </div>
            <div v-if="instancesLoader">{{ $t("loading.loading") }}</div>
            <div v-else-if="!instancesIsEmpty(getMethod())">
                <div style="display: none">
                    {{ next }} <br /><br />
                    {{ prev }} <br /><br />
                </div>
                <div class="photos-list" :class="{ 'photos-list-puzzle': isPuzzle }">
                    <div v-for="(instance, index) in instances" :key="instance.id" :ref="'element' + index"
                        class="photos-item" :class="['element' + index, { 'photos-item-puzzle': isPuzzle }]">
                        <div class="photos-inner">
                            <!-- <div v-if="instance.condition_type === 0" class="photos-moderation"></div> -->
                            <div v-if="instance.condition_type === 0" class="photos-moderation"></div>
                            <div class="photos-image" :class="{ 'photos-image-video': isVideo }" @click="
                                $modal.show('photo-details', {
                                    id: instance.id,
                                    isAlbum: true,
                                    isVideo: isVideo,
                                })
                                " :style="{
        'background-image': instance.image
            ? 'url(' + instance.image + ')'
            : '',
    }">
                                <div v-if="isVideo && !instance.image" class="photos-process">
                                    <span v-if="instance.ready">
                                        {{ $t("photos.videoProcessingError") }}
                                    </span>
                                    <span v-else>
                                        {{ $t("photos.videoProcessing") }}
                                    </span>
                                </div>
                            </div>
                            <button v-if="profileId == user.id" @click.stop.prevent="removePhoto([instance.id])"
                                class="delete"></button>
                            <div v-else-if="isPuzzle && instance.bought" class="photos-puzzle bought">
                                <div @click="$modal.show('puzzle', { photoId: instance.id })" class="link-blue-underlined">
                                    {{ $t("photos.continueAssembling") }}
                                </div>
                            </div>
                            <div v-else-if="isPuzzle &&
                                !instance.bought &&
                                !initIsEmpty('init') &&
                                init.costs
                                " class="photos-puzzle new">
                                <span @click.stop.prevent="buy(instance.id)" class="link-inherit"
                                    :class="{ loader: buyLoader }">
                                    {{ $t("photos.buy") }}
                                </span>
                                <div class="photos-puzzle-price">
                                    {{ puzzlePrice }}
                                </div>
                            </div>
                            <div v-if="!isPuzzle" class="photos-likes">
                                {{ instance.likes }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="photos-bottom">
                    <div v-if="moreLoader">
                        <button class="button-loader"></button>
                    </div>
                    <div class="photos-count">
                        {{ count }}
                        {{ isVideo ? $t("photos.video") : $t("photos.photo") }}
                    </div>
                </div>
            </div>
            <div v-else-if="instancesErrors && instancesErrors.vip_settings">
                {{ $t("photos.view") }}
                {{ isVideo ? $t("photos.video") : $t("photos.photo") }}
                {{ $t("photos.availableOnlyFriendsVIPs") }}
            </div>
            <div v-else class="text">
                {{ $t("photos.list") }}
                {{ isVideo ? $t("photos.video") : $t("photos.photo") }}
                {{ $t("photos.blank") }}
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { removePhoto } from "@/mixins/removePhoto";
import redirectButton from "@/components/Buttons/Redirect";
import { observeListEnd } from "@/mixins/observeListEnd";
import { declineNouns } from "@/mixins/declineNouns";

export default {
    name: "Photos",
    props: {
        i18n: Object,
    },
    components: {
        redirectButton,
    },
    mixins: [removePhoto, observeListEnd, declineNouns],
    data() {
        return {
            profileId: "",
            albumId: "",
            pageLoader: true,
            instancesLoader: true,
            moreLoader: false,
            moreIndex: 0,
            observer: null,
            buyLoader: false,
            showContext: false,
            isVideo: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            bought: "puzzles/fetchBought",
            init: "init/fetchInit",
            initIsEmpty: "init/isEmpty",
        }),
        shortenedOwnerName() {
            if (this.album.owner.name.length > 12) {
                return "...";
            }
            return this.album.owner.name;
        },
        instances() {
            return this.$store.getters[
                this.getMethod() + "/fetch" + this.getMethod(true)
            ];
        },
        instancesErrors() {
            return this.$store.getters[this.getMethod() + "/errors"];
        },
        instancesIsEmpty() {
            return this.$store.getters[this.getMethod() + "/isEmpty"];
        },
        count() {
            return this.$store.getters[
                this.getMethod() + "/fetch" + this.getMethod(true) + "Count"
            ];
        },
        next() {
            return this.$store.getters[
                this.getMethod() + "/fetch" + this.getMethod(true) + "Next"
            ];
        },
        prev() {
            return this.$store.getters[
                this.getMethod() + "/fetch" + this.getMethod(true) + "Prev"
            ];
        },
        albumsIsEmpty() {
            return this.$store.getters[this.getAlbumMethod() + "/isEmpty"];
        },
        album() {
            return this.$store.getters[
                this.getAlbumMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "Details"
            ];
        },
        isPuzzle: function () {
            return this.album.album_type == 2;
        },
        puzzlePrice() {
            if (this.user.vip) {
                return Math.ceil(
                    (this.init.costs.puzzle_price *
                        (100 - this.init.costs.vip_discount)) /
                    100
                );
            }
            return this.formatPrice(this.init.costs.puzzle_price);
        },
    },
    created() {
        this.isVideo = this.$route.meta && this.$route.meta.type == "videos";
        this.profileId = this.$route.params.profileId;
        this.albumId = this.$route.params.albumId;
        this.getAlbumDetails();
        this.getInstances();
        this.observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting === true) {
                    this.showMore();
                }
            },
            { threshold: [0] }
        );
    },
    watch: {
        $route(to, from) {
            if (to != from) {
                this.pageLoader = true;
                this.profileId = this.$route.params.profileId;
                this.albumId = this.$route.params.albumId;
                this.isVideo = this.$route.meta && this.$route.meta.type == "videos";
                this.getAlbumDetails();
                this.getInstances();
            }
        },
    },
    methods: {
        getMethod(capitalize = false, method = "", isPlural = true) {
            let str = this.isVideo ? "video" : "photo";
            if (capitalize) str = str.charAt(0).toUpperCase() + str.slice(1);
            if (isPlural) str += "s";
            return str + method;
        },
        getAlbumMethod(method = "") {
            return (this.isVideo ? "videoAlbums" : "albums") + method;
        },
        getAlbumDetails() {
            this.$store
                .dispatch(this.getAlbumMethod("/getDetails"), this.albumId)
                .then(() => {
                    this.pageLoader = false;
                    //console.log(this.album);
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        getInstances() {
            this.$store
                .dispatch(this.getMethod(false, "/getAlbum"), this.albumId)
                .then(() => {
                    this.instancesLoader = false;
                    this.updateMoreIndex();
                    this.observeListEnd("element");
                })
                .catch(() => {
                    this.instancesLoader = false;
                });
        },
        buy(id) {
            if (parseFloat(this.puzzlePrice) > parseFloat(this.user.balance)) {
                this.$modal.show("dialog", {
                    title: this.$t("photos.insufficientFunds"),
                    text: this.$t("photos.notEnoughMoneyBuyPuzzle"),
                    buttons: [
                        {
                            title: this.$t("photos.replenishBalance"),
                            handler: () => {
                                this.$modal.hide("dialog");
                                this.$modal.show("balance-in");
                            },
                        },
                        {
                            title: this.$t("photos.close"),
                        },
                    ],
                });
                return;
            }
            this.buyLoader = true;
            this.$store
                .dispatch("puzzles/buy", id)
                .then(() => {
                    this.buyLoader = false;
                    this.$store.dispatch("photos/setBought", id);
                    this.$modal.show("puzzle", { photoId: id });
                })
                .catch(() => {
                    this.buyLoader = false;
                });
        },
        updateMoreIndex() {
            for (let i = 0; i < this.count; i++) {
                if (!this.instances[i]) {
                    this.moreIndex = i - 2;
                    return;
                }
            }
        },
        showMore() {
            let firstEmpty;
            for (let i = 0; i < this.count; i++) {
                if (!this.instances[i]) {
                    firstEmpty = i;
                    break;
                }
            }
            if (this.next && firstEmpty) {
                this.moreLoader = true;
                this.$store
                    .dispatch(this.getMethod(false, "/getNext"))
                    .then(() => {
                        this.observeListEnd("element", false, true, true);
                        this.moreLoader = false;
                    })
                    .catch(() => {
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
        clickOutsideContext() {
            this.showContext = false;
        },
        formatPrice(price) {
            let arr = price.split(".");
            return arr[1] == "00" ? arr[0] : price;
        },
        calcAge() {
            let bDateArr = this.album.owner.birthday.split(".");
            let bDate = new Date();
            bDate.setDate(bDateArr[0]);
            bDate.setMonth(bDateArr[1] - 1);
            bDate.setFullYear(bDateArr[2]);
            bDate = bDate.getTime();
            let years = new Date(+new Date() - bDate).getFullYear() - 1970;
            return years;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/pages/_photos";
@import "~@/assets/styles/pages/_albums";
@import "~@/assets/styles/pages/_album-edit";
</style>
